import { createFileRoute } from "@tanstack/react-router";

import { PlanTab } from "@/features/wonda/components/PlanTab";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/account/plan",
)({
  component: PlanTab,
});
